export enum AccountType {
  Customer = 'Customer',
  POC = 'POC',
  Inactive = 'Inactive',
  Free = 'Free',
  Internal = 'Internal',
}
